export const base = [
  [
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "01", "00", "00", "01", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
  ],
  [
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "01", "00", "00", "01", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
  ],
  // Body
  [
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
  ],
  [
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "04", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
  ],
  [
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "01", "00"],
    ["00", "00", "00", "01", "02", "01", "01", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
  ],
  [
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "01", "01", "00", "00", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["04", "01", "02", "01", "01", "01", "01", "02", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
  ],
  // Head
  [
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "01", "01", "00", "00", "01", "01", "00"],
    ["00", "01", "01", "01", "01", "01", "01", "01", "01"],
    ["00", "00", "01", "01", "01", "01", "01", "01", "00"],
    ["00", "00", "01", "01", "01", "01", "01", "01", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
  ],
  [
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "01", "00", "00", "00", "00", "01", "00"],
    ["00", "01", "00", "00", "00", "00", "00", "00", "01"],
    ["00", "01", "01", "01", "01", "01", "01", "01", "01"],
    ["00", "01", "01", "01", "01", "01", "01", "00", "01"],
    ["00", "01", "01", "00", "00", "00", "00", "01", "01"],
    ["00", "00", "01", "01", "00", "00", "01", "01", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
  ],
  // Face
  [
    ["00", "00", "01", "01", "00", "00", "01", "01", "00"],
    ["00", "01", "00", "00", "01", "01", "00", "00", "01"],
    ["00", "01", "00", "00", "00", "00", "00", "00", "01"],
    ["00", "02", "01", "01", "01", "01", "01", "01", "02"],
    ["00", "01", "00", "05", "05", "05", "05", "00", "01"],
    ["00", "03", "00", "00", "00", "00", "00", "00", "03"],
    ["00", "00", "03", "00", "00", "00", "00", "03", "00"],
    ["00", "00", "00", "03", "03", "03", "03", "00", "00"],
  ],
  [
    ["00", "00", "01", "00", "00", "00", "00", "01", "00"],
    ["00", "01", "00", "01", "01", "01", "01", "00", "01"],
    ["00", "02", "00", "00", "00", "00", "00", "00", "02"],
    ["00", "02", "01", "01", "01", "01", "01", "01", "02"],
    ["00", "01", "07", "05", "05", "05", "05", "07", "01"],
    ["00", "03", "00", "00", "00", "00", "00", "00", "03"],
    ["00", "03", "00", "00", "00", "00", "00", "00", "03"],
    ["00", "00", "03", "03", "03", "03", "03", "03", "00"],
  ],
  [
    ["00", "00", "01", "00", "00", "00", "00", "01", "00"],
    ["00", "01", "00", "01", "01", "01", "01", "00", "01"],
    ["00", "02", "00", "00", "00", "00", "00", "00", "02"],
    ["00", "04", "01", "01", "01", "01", "01", "01", "04"],
    ["00", "01", "07", "05", "05", "05", "05", "07", "01"],
    ["00", "03", "00", "00", "00", "00", "00", "00", "03"],
    ["00", "03", "00", "00", "00", "00", "00", "00", "03"],
    ["00", "00", "03", "03", "03", "03", "03", "03", "00"],
  ],
  [
    ["00", "00", "01", "01", "00", "00", "01", "01", "00"],
    ["00", "01", "00", "00", "01", "01", "00", "00", "01"],
    ["00", "01", "00", "00", "00", "00", "00", "00", "01"],
    ["00", "01", "01", "01", "01", "01", "01", "01", "01"],
    ["00", "01", "00", "06", "06", "06", "06", "00", "01"],
    ["00", "01", "00", "00", "00", "00", "00", "00", "01"],
    ["00", "03", "00", "00", "00", "00", "00", "00", "03"],
    ["00", "00", "03", "03", "03", "03", "03", "03", "00"],
  ],
  // Head
  [
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "01", "00", "00", "00", "00", "01", "00"],
    ["00", "01", "00", "00", "00", "00", "00", "00", "01"],
    ["00", "01", "01", "01", "01", "01", "01", "01", "01"],
    ["00", "01", "00", "00", "00", "00", "00", "00", "01"],
    ["00", "01", "00", "00", "00", "00", "00", "00", "01"],
    ["00", "00", "01", "00", "00", "00", "00", "01", "00"],
    ["00", "00", "00", "03", "03", "03", "03", "00", "00"],
  ],
  [
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "01", "01", "01", "01", "01", "01", "00"],
    ["00", "00", "01", "01", "01", "01", "01", "01", "00"],
    ["00", "00", "01", "00", "00", "00", "00", "01", "00"],
    ["00", "00", "01", "00", "00", "00", "00", "01", "00"],
    ["00", "00", "01", "01", "00", "00", "01", "01", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
  ],
  [
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "01", "01", "00", "00", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "00", "00", "01", "01", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
  ],
];
export const standSpaceman = base;

const baseSitSpaceman = [...base];
export const sitSpaceman = [
  [
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "01", "00", "00", "01", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
  ],
  [
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "01", "00", "00", "01", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
  ],
  [
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "04", "01", "01", "01", "01", "04", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "00", "01", "00", "00", "01", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
  ],
  [
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "01", "01", "01", "01", "01", "01", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
  ],
  [
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "01", "01", "00", "00", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "02", "01", "01", "01", "01", "02", "00"],
    ["00", "00", "00", "01", "02", "01", "01", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
  ],
  ...baseSitSpaceman.slice(6),
];

const baseHarvestingSpaceman = [...base];
export const harvestingSpaceman = [
  ...baseHarvestingSpaceman.splice(0, 2),
  [
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "08", "00"],
  ],
  [
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "10", "00"],
    ["00", "00", "04", "01", "01", "01", "01", "04", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "10", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "10", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "08", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "08", "00"],
  ],
  [
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "01", "01", "01", "01", "01", "01", "00"],
    ["00", "00", "00", "01", "02", "01", "01", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "08", "00"],
  ],
  [
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "01", "01", "00", "00", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "02", "01", "01", "01", "01", "02", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
  ],
  ...baseHarvestingSpaceman.slice(4),
];

const baseLyingSpaceman = [...base];
export const lyingSpaceman = [
  [
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "01", "00", "00", "01", "00", "00"],
    ["00", "00", "00", "01", "00", "00", "01", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
  ],
  [
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "01", "00", "00", "01", "00", "00"],
    ["00", "00", "00", "01", "00", "00", "01", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
  ],
  [
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
  ],
  [
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
  ],
  [
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "00", "01", "02", "01", "01", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
  ],
  [
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "01", "01", "00", "00", "00"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["04", "01", "02", "01", "01", "01", "01", "02", "01", "04"],
    ["00", "00", "00", "01", "01", "01", "01", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
    ["00", "00", "00", "00", "00", "00", "00", "00", "00"],
  ],
  ...baseLyingSpaceman.slice(6),
];
